import React from "react";
import Dashboard from '../../components/provider/dashboard';




export default function DashBoard() {
 return (
        <div className="App">
          <Dashboard/>
        </div>
      );
}